import { InlineBanner, Text } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import React from 'react'

interface Props {
  shouldShowErrorBanner: boolean
}

export const SaleErrorBanner: React.FC<Props> = ({ shouldShowErrorBanner }) => {
  const t = useT()

  return (
    shouldShowErrorBanner && (
      <InlineBanner
        variant="negative"
        icon="warning"
        data-cy="sale-error-banner"
      >
        <Text type="label">
          {t('Fix the sale errors before continuing', {
            _context: 'Sale error banner',
          })}
        </Text>
      </InlineBanner>
    )
  )
}
